<template>
  <div class="e-dialog-actions" :class="{ 'flexible-button': props.flexibleButton }">
    <slot />
  </div>
</template>

<script setup>
const props = defineProps({
  flexibleButton: {
    type: Boolean,
    default: true,
  },
})
</script>

<style lang="scss">
@import 'vuetify/lib/styles/settings/variables';
@import '../../scss/styles';
.e-dialog-actions {
  padding: 16px;
  display: flex;
  gap: 12px;
}

@media #{map-get($display-breakpoints, 'xs')} {
  .e-dialog-actions {
    gap: 16px;
    padding: 8px 24px 32px;
    > .e-btn {
      flex-grow: 1;
    }
    &.flexible-button {
      // large btn styles
      > .e-btn {
        height: 44px;
        &.v-btn--icon {
          .v-icon {
            font-size: 24px;
          }
          height: 44px;
          width: 44px;
        }
      }
    }
  }
}
</style>
